import React, {
  useEffect,
  useState,
} from 'react';
import { useStores } from '../../hooks/use-stores';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';
import {
  Alert,
  Col,
  Row,
} from 'react-bootstrap';
import InfoTooltip from '../../components/InfoTooltip';

const TicketNumberSettings = () => {
  const { settingsStore } = useStores();
  const { t } = useTranslation();
  const [value, setValue] = useState<number>(0);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    (async () => {
      try {
        const data = await settingsStore.getTicketNumberSequence();
        settingsStore.ticketNumberSequence = data?.start;
        setValue(settingsStore.ticketNumberSequence);
      } catch(err: any) {
        setError(`Couldn't load the data. ${err?.message}`);
      }
    })();
  }, [settingsStore]);

  const save = async (value: number) => {
    setError('');

    if (value <= 0) {
      setError(t('Value must be greater than 0'));
      return;
    }

    try {
      await settingsStore.saveTicketNumberSequence(value);
      settingsStore.ticketNumberSequence = value;
    } catch (err: any) {
      setError(`Couldn't save data. ${err?.message}`);
    }
  };

  const reset = () => {
    setError('');
    setValue(settingsStore.ticketNumberSequence);
  };

  return (
    <>
      <Row>
        <Col sm={12}>
          <label>
            {t('Ticket Number Sequence')}
            {<InfoTooltip text={t('This is the starting point for the ticket number, which resets every day')} />}
          </label>
        </Col>
      </Row>
      <Row>
        <Col sm={2}>
          <input
            name="value"
            type="number"
            min={1}
            value={value || ''}
            onChange={(e: any) => setValue(e.target.value)}
            className="form-control input-sm narrow-pad"
          />
        </Col>
        <Col sm={3}>
          <Button
            className={'btn-sm btn-default'}
            onClick={() => reset()}
            title={t('Reset')}
          >
            {t('Reset')}
          </Button>{' '}
          <Button
            className={'btn-sm btn-primary'}
            onClick={() => save(value)}
            title={t('Set')}
          >
            {t('Set')}
          </Button>
        </Col>
      </Row>
      <Row className="margin-top-10">
        <Col sm={6}>
          {!!error && (
            <Alert bsStyle="danger">{error}</Alert>
          )}
        </Col>
      </Row>
    </>
  );
};

export { TicketNumberSettings };
